// Thin wrapper around the browser's Notification Web API so a CRM follow-up
// reminder is visible (with sound -- see beep.js) even when this tab isn't
// focused: a different browser tab, or a completely different application,
// as long as the browser itself is still running somewhere in the
// background (same ceiling as WhatsApp Web's desktop alerts). It cannot
// wake a fully-closed browser -- that needs Web Push + a service worker, a
// materially bigger feature, intentionally out of scope here.
//
// Platform note: iOS Safari does not support this API for an ordinary
// website tab at all (only for a PWA installed to the home screen, via Web
// Push) -- there is no workaround for a plain web page on iOS.

export const isNotificationSupported = () =>
  typeof window !== "undefined" && "Notification" in window;

export const getNotificationPermission = () =>
  isNotificationSupported() ? Notification.permission : "unsupported";

export const requestNotificationPermission = async () => {
  if (!isNotificationSupported()) return "unsupported";
  try {
    return await Notification.requestPermission();
  } catch {
    return Notification.permission;
  }
};

export const showBrowserNotification = (title, options = {}) => {
  if (!isNotificationSupported() || Notification.permission !== "granted") return null;
  try {
    const notif = new Notification(title, options);
    notif.onclick = () => {
      window.focus();
      notif.close();
    };
    return notif;
  } catch {
    // Some browsers throw if called from a background/non-visible context
    // in certain edge cases -- never let this break the in-app reminder.
    return null;
  }
};
